import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class HolidaysDataTable {
  constructor() {
    $(document).ready(function() {
      showHolidaysTable();
    });

    $(document).on("turbo:render", function() {
      showHolidaysTable();
    });

    function showHolidaysTable() {
      $('#holidays-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#holidays-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "name"},
          {"data": "holiday_date"},
          {"data": "provider"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
